<fc-search-input
  [label]="'FC_LOCATION_SECTOR.LABEL' | translate"
  [control]="control"
  [search]="search"
  [reload$]="reload$"
  [displayWith]="displayWith"
  [showSearchIcon]="showSearchIcon"
  [requiredMark]="requiredMark"
  [preloadOptions]="preloadOptions"
  [searchOnFocus]="searchOnFocus"
  [translateErrorPrefix]="translateErrorPrefix"
  [enableInfiniteScroll]="enableInfiniteScroll"
  [showChevronIcon]="showChevronIcon"
></fc-search-input>
